// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const TelegramIcon = (props: IconProps) => (
  <Icon viewBox="0 0 49 48" fill="none" {...props}>
    <path d="M18.9111 37.6391C19.613 37.6391 20.014 37.2395 20.5153 36.8399L25.027 32.5441L19.4124 29.1475" fill="currentColor" />
    <path
      d="M19.4119 29.1488L32.9471 39.039C34.3507 39.9381 35.5539 39.4386 35.9549 37.6404L41.4692 11.8661C41.9706 9.6683 40.5669 8.6693 39.063 9.3686L6.8793 21.7562C4.77382 22.5554 4.77382 23.8541 6.47825 24.3536L14.7999 26.951L33.8494 14.8631C34.7518 14.3636 35.5539 14.5634 34.9523 15.2627"
      fill="currentColor"
    />
  </Icon>
);
